import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';

import environment from '../libs/environment';

//actions
import { postUpdated, updateFilterSelected } from '../actions';

class AttorneyField extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
    this.onChange = this.onChange.bind(this);
  }

  async getPeople() {
    const response = await axios.get(`${environment.domain}${environment.dataPath}/people.json`);
    let data = await response.data;
    // sort alphabetically
    data.sort((a, b) => {
      if (a.last_name.charAt(0).toUpperCase() < b.last_name.charAt(0).toUpperCase()) {
        return -1;
      }
      if (a.last_name.charAt(0).toUpperCase() > b.last_name.charAt(0).toUpperCase()) {
        return 1;
      }

      if (a.last_name.charAt(1).toUpperCase() < b.last_name.charAt(1).toUpperCase()) {
        return -1;
      }

      if (a.last_name.charAt(1).toUpperCase() > b.last_name.charAt(1).toUpperCase()) {
        return 1;
      }

      if (a.last_name.charAt(2).toUpperCase() < b.last_name.charAt(2).toUpperCase()) {
        return -1;
      }

      if (a.last_name.charAt(2).toUpperCase() > b.last_name.charAt(2).toUpperCase()) {
        return 1;
      }

      return 0;
    });

   

    this.setState({
      data: data
    });
   
  }

  componentDidMount() {
    this.getPeople();
  }

  onChange = e => {
    let selected = this.selectRef.current.value;
    //update filters in redux
    this.props.updateFilterSelected('attorney', selected);
    this.props.postUpdated('asc', selected, this.props.data, 'attorney');
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.filters.clear_filter.active) {
      this.clearField();
    }
  }

  clearField() {
    this.selectRef.current.value = '';
  }

  render() {
    
    if (this.state && this.state.data) {
      
      const peopleArray = this.state.data.map((element, i) => {
        return <option value={element.title} key={i}>{element.last_name} {element.first_name}</option>
      });
      
      return (
        <select className="form-control" ref={this.selectRef} onChange={this.onChange}>
          <option value="">Attorney</option>
          {peopleArray}
        </select>
      );
    } else {
      return null;
    }
  }
}

AttorneyField.propTypes = {
  data: PropTypes.array
};

const mapDispatchToProps = dispatch => {
  return {
    postUpdated: (sortBy, value, filteredData, filterSelected) =>
      dispatch(postUpdated(sortBy, value, filteredData, filterSelected)),
    updateFilterSelected: (filtername, value) => dispatch(updateFilterSelected(filtername, value))
  };
};

const mapStateToProps = state => {
  return {
    type: state.postData.type,
    filteredData: state.postData.filteredData,
    data: state.postData.data,
    filters: state.filters
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AttorneyField);
